<template>
<div class="chapter">
<div class="inner_page">
<p class="images3"><img alt="Image" src="images/img4.jpg" style="max-width:100%;"/></p>
<p class="head1">Welcome to Successful Gardening in Utah!</p>
<p class="noindent_2"><span class="dropcap">W</span>hat stops you from loving your garden?</p>
<p class="indent_1">Weeds, bugs, water bills, struggling plants, stunted harvests, expensive “fixes”—these are the things that stop many people from growing more of their own food.</p>
<p class="indent_1">Gardening in Utah is unlike gardening almost anywhere else. We face unique challenges, but there are simple solutions that can turn your garden from a weed-infested burden to a source of health, food, and joy. If your garden feels like a burden, you are not likely to keep it up. On top of which, you are not likely to teach your children the skills they will need to love growing their own food. My goal in writing this book is to make stress-free, weed-free gardens filled with delicious food possible for everyone who is interested in learning how.</p>
<p class="indent_1">The advice in most gardening books—written by authors who have never grown anything in the high desert climate of the Rocky Mountain West—is unusable here. Let’s examine, one by one, the unique challenges that can derail any Utah garden if you don’t know the tips and tricks needed for success here. This book will give you specific solutions for every unique growing challenge in our beautiful desert state.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?2c20c4f2